import React from "react";

import styles from "./FeedbackOutro.module.scss";

import PageContent from "../../../../components/PageContent";
import Section from "../../../../components/Section";
import Button from "../../../../components/Button";
import SuccessIcon from "../../../../images/icons/user_feedback_icons/success.svg";
import { useHistory } from "react-router-dom";

export const FeedbackOutro = () => {
  const history = useHistory();

  function handleClick() {
    history.push("/dashboard");
  }
  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <img
          src={SuccessIcon}
          alt="Illustration of Feedback Form"
          style={{ maxWidth: "220px" }}
        />
        <h1 className={styles.titleText}>Thank you for sharing</h1>
        <p className={styles.description}>
          We appreciate your time and effort in providing us with your thoughts.
          Your input helps us better understand your needs and ensure we're
          delivering the best experience possible.
        </p>

        <PageContent indent>
          <Section>
            <div className={styles.detailsContainer}>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                onClick={handleClick}
              >
                Back to Dashboard
              </Button>
            </div>
          </Section>
        </PageContent>
      </div>
    </div>
  );
};
